import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { NewPatientState } from './newPatient.types';

const initialState: NewPatientState = {
  newPatientCreationDetails: {
    isShowPrompt: false,
    redirectURL: '',
    targetSource: '',
    errorInstNameAfterCreate: '',
  },
  patientSources: [],
};

const newPatientSlice = createSlice({
  initialState,
  name: 'newPatient',
  reducers: {
    resetAfterCreateFlags(state) {
      state.newPatientCreationDetails = initialState.newPatientCreationDetails;
    },
    resetPatientSources(state) {
      state.patientSources = [];
    },
    resetPatientTargetSource(state) {
      state.newPatientCreationDetails.targetSource = '';
    },
    resetRedirectURL(state) {
      state.newPatientCreationDetails.redirectURL = '';
    },
    setIsShowPrompt(state, action: PayloadAction<boolean>) {
      state.newPatientCreationDetails.isShowPrompt = action.payload;
    },
    setNewPatientTargetSource(state, action: PayloadAction<string>) {
      state.newPatientCreationDetails.targetSource = action.payload;
    },
    setPatientSources(state, action: PayloadAction<string[]>) {
      state.patientSources = action.payload;
    },
    setRedirectURL(state, action: PayloadAction<string>) {
      state.newPatientCreationDetails.redirectURL = action.payload;
    },
    setErrorInstNameAfterCreate(state, action: PayloadAction<string>) {
      state.newPatientCreationDetails.errorInstNameAfterCreate = action.payload;
    },
  },
});

export const { actions: newPatientAction } = newPatientSlice;

export default newPatientSlice.reducer;
